package io.horion.cv.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement.Center
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Alignment.CenterHorizontally
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronLeft
import com.varabyte.kobweb.silk.components.overlay.Overlay
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.api.datasource.payement.PaymentMethod
import io.horion.cv.components.Footer
import io.horion.cv.components.Topbar
import io.horion.cv.components.widgets.FeautureItem
import io.horion.cv.di.koinGet
import io.horion.cv.styles.*
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import io.horion.cv.utils.Validators
import io.horion.cv.viewModel.PayViewModel
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Text

@Page("/payment")
@Composable
fun PaymentPage() {
    val ctx = rememberPageContext()
    val payViewModel = koinGet<PayViewModel>()
    val payUiState = payViewModel.paymentUiState

    var selectedPayment by remember { mutableStateOf("") }
    var phoneNumber by remember { mutableStateOf("") }
    var showIncompatibilityPopup by remember { mutableStateOf(false) }
    var detectedOperator: String? by remember { mutableStateOf("") }

    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val pageBg     = if (isDark) Colors.DarkBG   else Colors.White
    val titleColor = if (isDark) Colors.White     else Colors.DarkBlue
    val iconFilter = if (isDark) "none"           else "invert(0.8)"

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(pageBg)
            .styleModifier { property("transition", "background-color 300ms ease") },
        horizontalAlignment = CenterHorizontally
    ) {
        Topbar()

        LaunchedEffect(Unit){
            payViewModel.cleanError()
        }

        if (showIncompatibilityPopup) {
            IncompatibilityPopup(
                selectedOperator = selectedPayment,
                detectedOperator = detectedOperator ?: "",
                phone = payViewModel.paymentUiState.phone,
                onDismiss = { showIncompatibilityPopup = false }
            )
        }

        Column(
            modifier = PaymentContainerStyle.toModifier(),
            horizontalAlignment = CenterHorizontally
        ) {
            Row(
                modifier = PaymentHeaderRowStyle.toModifier().fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically
            ) {

                FaChevronLeft(
                    modifier = PaymentBackIconStyle.toModifier()
                        .margin(right = 15.px)
                        .cursor(Cursor.Pointer)
                        .styleModifier { property("filter", iconFilter) }
                        .onClick { ctx.router.navigateTo("/price") }
                )

                SpanText(
                    text = "Configuration de votre paiement",
                    modifier = PaymentTitleStyle.toModifier()
                        .color(titleColor)
                        .fontWeight(FontWeight.Bold)
                        .fontFamily(INTER)
                )
            }

            Div(
                attrs = PaymentContentWrapperStyle.toModifier().toAttrs()
            ) {
                PaymentFormSection(
                    selectedPayment = selectedPayment,
                    onPaymentSelected = {
                        selectedPayment = it
                        val method = if (selectedPayment == "orange") {
                            PaymentMethod.OM
                        } else {
                            PaymentMethod.MOMO
                        }
                        payViewModel.updateMethod(method)
                    },
                    phoneNumber = payUiState.phone,
                    onPhoneChanged = { payViewModel.updatePhone(it) },
                    onNext = {
                        detectedOperator = Validators.getOperator(payViewModel.paymentUiState.phone)
                        val isCompatible = selectedPayment.isNotEmpty()
                                && payUiState.phone.isNotEmpty()
                                && detectedOperator != null
                                && detectedOperator == selectedPayment

                        if (isCompatible) {
                            payViewModel.cleanError()
                            ctx.router.navigateTo("/confirm-payment")
                        } else {
                            showIncompatibilityPopup = true
                        }
                    }
                )
                PriceSummaryCard()
            }

        }
        Footer()
    }
}

@Composable
fun PaymentFormSection(
    selectedPayment: String,
    onPaymentSelected: (String) -> Unit,
    phoneNumber: String,
    onPhoneChanged: (String) -> Unit,
    onNext: () -> Unit,
    modifier: Modifier = Modifier
) {

    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val labelColor  = if (isDark) Colors.White      else Colors.DarkBlue
    val inputBg     = if (isDark) Colors.holder     else Colors.PriceGray
    val inputColor  = if (isDark) Colors.White      else Colors.Primary

    Column(
        modifier = PaymentFormSectionStyle.toModifier().then(modifier)
    ) {
        SpanText(
            text = "Choisir un opérateur",
            modifier = PaymentOperatorLabelStyle.toModifier()
                .color(labelColor)
                .fontFamily(INTER)
                .fontWeight(FontWeight.Normal)
        )

        Row(
            modifier = PaymentOperatorsRowStyle.toModifier().fillMaxWidth()
        ) {
            PaymentCard(
                image = "/orange.png",
                selected = selectedPayment == "orange",
                accentColor = Colors.orange,
                imageModifier = OrangeImageStyle.toModifier()

            ) {
                onPaymentSelected("orange")
            }
            PaymentCard(
                image = "/mtn.png",
                selected = selectedPayment == "mtn",
                accentColor = Colors.yellow,
                imageModifier = MtnImageStyle.toModifier()
            ) {
                onPaymentSelected("mtn")
            }
        }

        SpanText(
            text = "Numéro de téléphone",
            modifier = PaymentPhoneLabelStyle.toModifier()
                .fontFamily(INTER)
                .fontWeight(FontWeight.Medium)
                .color(labelColor)
        )
        Input(
            type = InputType.Text,
            attrs = Modifier
                .fillMaxWidth()
                .height(50.px)
                .borderRadius(10.px)
                .backgroundColor(inputBg)
                .color(inputColor)
                .padding( 12.px)
                .toAttrs {
                    placeholder(if (selectedPayment == "orange") "699 99 99 99" else "677 77 77 77")
                    value(phoneNumber)
                    onInput { onPhoneChanged(it.value) }
                }
        )

        Box(Modifier.height(20.px))

        Button(
            onClick = { onNext() },
            modifier = SubscribeButtonStyle.toModifier()
                .then(PaymentFormButtonStyle.toModifier())
                .fillMaxWidth()
                .fontFamily(INTER)
                .fontWeight(FontWeight.Medium)
                .borderRadius(30.px)
                .color(Colors.White),
        ) {
            Text("Suivant")
        }

    }
}

@Composable
fun PaymentCard(
    image: String,
    selected: Boolean,
    accentColor: Color,
    imageModifier: Modifier = Modifier,
    modifier: Modifier = Modifier,
    onClick: () -> Unit
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val cardBg = if (isDark) Colors.holder else Colors.fillbox

    Column(
        modifier = PaymentCardContainerStyle.toModifier()
            .then(modifier)
            .borderRadius(20.px)
            .backgroundColor(cardBg)
            .border(
                width = 1.px,
                style = LineStyle.Solid,
                color = accentColor
            ),
        horizontalAlignment = CenterHorizontally,
        verticalArrangement = Center
    ) {

        Row(
            modifier = PaymentCardInnerRowStyle.toModifier().fillMaxWidth(),
            horizontalArrangement = Center,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Box(
                modifier = Modifier
                    .size(18.px)
                    .borderRadius(50.percent)
                    .cursor(Cursor.Pointer)
                    .onClick { onClick() }
                    .backgroundColor(if (selected) Colors.checkbox else
                        if (isDark) Colors.DarkBG else Colors.PriceGray)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = if (selected) Colors.checkbox else Colors.borders
                    ),
                contentAlignment = Alignment.Center
            ) {
                if (selected) {
                    Box(
                        modifier = PaymentCardDotIndicatorStyle.toModifier()
                            .borderRadius(50.percent)
                            .backgroundColor(Colors.White)
                    )
                }
            }

            Image(
                src = image,
                description = "paiement image",
                modifier = imageModifier
                    .styleModifier {
                        property("object-fit", "contain")
                        property("filter", if (isDark) "brightness(1.1)" else "none")
                    }
            )
        }
    }
}

@Composable
fun IncompatibilityPopup(
    selectedOperator: String,
    detectedOperator: String,
    phone: String = "",
    onDismiss: () -> Unit
) {
    val operatorNames = mapOf(
        "orange" to "Orange Money",
        "mtn" to "MTN Mobile Money"
    )

    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val popupBg    = if (isDark) Colors.holder    else Colors.White
    val titleColor = if (isDark) Colors.White     else Colors.Black
    val textColor  = if (isDark) Colors.LightGray else Colors.Primary
    val selectedName = operatorNames[selectedOperator.lowercase()] ?: selectedOperator
    val detectedName = operatorNames[detectedOperator.lowercase()] ?: detectedOperator

    Overlay(
        modifier = IncompatibilityPopupOverlayStyle.toModifier()
            .fillMaxSize()
            .backgroundColor(Color.rgba(0, 0, 0, 0.6f))
            .onClick { onDismiss() },
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = IncompatibilityPopupCardStyle.toModifier()
                .backgroundColor(popupBg)
                .borderRadius(24.px)
                .onClick { it.stopPropagation() }
                .styleModifier {
                    property("max-width", "90vw")
                    property("max-height", "85vh")
                    property("overflow-y", "auto")
                    property("box-sizing", "border-box")
                    property("box-shadow", "0 10px 25px rgba(0,0,0,0.2)")
                },
            horizontalAlignment = CenterHorizontally
        ) {
            SpanText(
                text = "⚠️",
                modifier = IncompatibilityPopupEmojiStyle.toModifier()
            )

            SpanText(
                text = "Incompatibilité détectée",
                modifier = IncompatibilityPopupTitleStyle.toModifier()
                    .fontFamily(INTER)
                    .fontWeight(FontWeight.Bold)
                    .color(titleColor)
                    .textAlign(TextAlign.Center)
            )

            SpanText(
                text = if (phone.isBlank()) {
                    "Veuillez saisir votre numéro de téléphone."
                } else {
                    "Vous avez sélectionné $selectedName, mais le numéro saisi correspond à $detectedName."
                },
                modifier = IncompatibilityPopupTextStyle.toModifier()
                    .fontFamily(INTER)
                    .color(textColor)
                    .textAlign(TextAlign.Center)
                    .styleModifier {
                        property("line-height", "1.5")
                        property("overflow-wrap", "break-word")
                    }
            )

            Button(
                onClick = { onDismiss() },
                modifier = IncompatibilityPopupButtonTextStyle.toModifier()
                    .fillMaxWidth()
                    .borderRadius(30.px)
                    .backgroundColor(Color.rgb(0x3B, 0x82, 0xF6))
                    .color(Colors.White)
                    .fontFamily(INTER)
                    .fontWeight(FontWeight.SemiBold)
                    .cursor(Cursor.Pointer)
            ) {
                SpanText("Corriger le numéro")
            }
        }
    }
}

@Composable
fun PriceSummaryCard(
    modifier: Modifier = Modifier
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val cardBg       = if (isDark) Colors.holder    else Colors.PriceGray
    val priceColor   = if (isDark) Colors.White     else Colors.DarkBlue
    val subtextColor = if (isDark) Colors.LightGray else Colors.Graytext

    Column(
        modifier = PriceSummaryCardStyle.toModifier()
            .then(modifier)
            .backgroundColor(cardBg)
            .styleModifier { property("transition", "background-color 300ms ease") }
            .borderRadius(32.px),
        horizontalAlignment = CenterHorizontally,
        verticalArrangement = Center
    ) {
        SpanText(
            text = "Facturé à la demande",
            modifier = Modifier
                .fontSize(14.px)
                .fontFamily(INTER)
                .fontWeight(FontWeight.Normal)
                .color(Colors.Lightblue)
                .margin(bottom = 20.px)
        )
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = PriceSummaryRowStyle.toModifier()
        ) {
            SpanText(
                text = "XAF 500",
                modifier = PriceSummaryAmountTextStyle.toModifier()
                    .fontFamily(INTER)
                    .fontWeight(FontWeight.Bold)
                    .color(priceColor)
            )
            SpanText(
                text = "/ document",
                modifier = PriceSummarySubtextStyle.toModifier()
                    .fontFamily(INTER)
                    .fontWeight(FontWeight.Normal)
                    .color(subtextColor)
                    .margin(left = 8.px)
            )
        }

        Column(
            modifier = PriceSummaryFeaturesContainerStyle.toModifier().gap(12.px)
        ) {
            FeautureItem(
                "Paiement unique, sans abonnement.",
            )
            FeautureItem(
                "Orange Money et MTN Mobile Money acceptés.",
            )
            FeautureItem(
                "Téléchargement immédiat après paiement.",
            )
        }
    }
}